import React, { memo, useMemo } from 'react'

import { useHandler, useMemoizedCall } from '@surglogs-app/hooks'
import {
  SignatureInput,
  useSignatureHandlers,
} from '@surglogs-app/ui.signature'

import { useTranslation } from '../../services'

interface CommonProps {
  editable?: boolean
  onRemove?: () => void
}

interface ValueWithUrl {
  url: string
}
type Value = string | ValueWithUrl | null

const is = (value: any): value is ValueWithUrl =>
  value && value instanceof Object && 'url' in value
const deriveValue = (value: Value): [string | null, boolean] => {
  // TODO: better way to detect this?
  const loading =
    typeof value === 'string' && value.startsWith('http')
      ? false
      : !!value && !is(value)

  let v: string | null = null
  if (value) {
    if (is(value)) {
      v = value.url
    }

    if (typeof value === 'string') {
      // && value.startsWith('http')
      v = value
    }
  }

  return [v, loading]
}

interface SignatureGroupSignatureInputProps extends CommonProps {
  value: Value
  onChange: (value: any) => void
  disabled?: boolean
  warning: any
  userId: number | null
  uploadAction: Parameters<typeof useSignatureHandlers>[0]['uploadAction']
}

export const SignatureGroupSignatureInputField = memo(
  ({
    value: originalValue,
    onChange,
    onRemove,
    editable,
    warning,
    userId,
    uploadAction,
    ...rest
  }: SignatureGroupSignatureInputProps) => {
    const { t } = useTranslation()
    const [value, uploading] = useMemoizedCall(deriveValue, [originalValue])

    const [add, remove] = useSignatureHandlers({
      onChange,
      userId: Number(userId),
      uploadAction,
    })

    const onRemoveClick = useHandler(() => {
      onRemove?.()
      return remove()
    })

    const removeButtonProps = useMemo(
      () => ({ onClick: onRemoveClick }),
      [onRemoveClick],
    )

    const addButtonProps = useMemo(
      () => ({
        'aria-label': 'add-signature-button',
        onClick: add,
        children: t('addSignatureButtonLabel'),
      }),
      [add, t],
    )

    return (
      <SignatureInput
        {...rest}
        {...{
          editable,
          value,
          removeButtonProps,
          addButtonProps,
          uploading: editable && uploading,
          warning,
        }}
      />
    )
  },
)
